import { ExtendedSectionMap } from 'models';

export function isFixedSection(section: ExtendedSectionMap): boolean {
  return section && !!section.get('height');
}
